import { SOCIALS } from "./constants";
import "./MenuSocials.scss";

export const MenuSocials = () => (
  <div className="menuSocials">
    {SOCIALS.map(({ link, title, Icon }) => (
      <a
        key={title}
        href={link}
        target="_blank"
        rel="noreferrer"
        aria-label={`Link to ${title} account`}
      >
        <Icon />
      </a>
    ))}
  </div>
);
